// Product Stories Container - Vanilla JS + Swiper
// Converted from jQuery/Slick to vanilla JS/Swiper

(function() {
  // Helper function for navigation selectors
  function getNavSelector(arrow) {
    if (!arrow) return null;
    if (typeof arrow === 'string') return arrow;
    if (arrow instanceof Element) return arrow;
    return null;
  }

  function initProductStories() {
    if (!document.querySelector('.stories-wrapper')) return;

    // Initialize image slider
    const imagesSliderEl = document.querySelector('.images-slider');
    if (imagesSliderEl && !imagesSliderEl.classList.contains('slick-initialized') && typeof Swiper !== 'undefined') {
      // Adicionar classe swiper no container
      imagesSliderEl.classList.add('swiper');

      let wrapper = imagesSliderEl.querySelector('.swiper-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';
        Array.from(imagesSliderEl.children).forEach(slide => {
          slide.classList.add('swiper-slide');
          wrapper.appendChild(slide);
        });
        if (wrapper.children.length > 0) imagesSliderEl.appendChild(wrapper);
        else return;
      }

      // Get or create navigation buttons
      let nextBtn = imagesSliderEl.querySelector('.swiper-button-next');
      let prevBtn = imagesSliderEl.querySelector('.swiper-button-prev');

      if (!nextBtn) {
        nextBtn = document.createElement('div');
        nextBtn.className = 'swiper-button-next';
        imagesSliderEl.appendChild(nextBtn);
      }

      if (!prevBtn) {
        prevBtn = document.createElement('div');
        prevBtn.className = 'swiper-button-prev';
        imagesSliderEl.appendChild(prevBtn);
      }

      // Add SVG icons to buttons if available
      if (window.arrows) {
        if (nextBtn && window.arrows.icon_next) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = window.arrows.icon_next;
          const iconSvg = tempDiv.querySelector('svg');
          if (iconSvg) {
            nextBtn.innerHTML = '';
            nextBtn.appendChild(iconSvg.cloneNode(true));
          }
        }
        if (prevBtn && window.arrows.icon_prev) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = window.arrows.icon_prev;
          const iconSvg = tempDiv.querySelector('svg');
          if (iconSvg) {
            prevBtn.innerHTML = '';
            prevBtn.appendChild(iconSvg.cloneNode(true));
          }
        }
      }

      window.imageSlider = new Swiper(imagesSliderEl, {
        loop: false,
        slidesPerView: 3,
        slidesPerGroup: 3,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
      });
      imagesSliderEl.classList.add('swiper-initialized');
    }

    // Initialize stories slider
    const storiesWrapperEl = document.querySelector('.stories-wrapper');
    if (storiesWrapperEl && !storiesWrapperEl.classList.contains('slick-initialized') && typeof Swiper !== 'undefined') {
      // Adicionar classe swiper no container
      storiesWrapperEl.classList.add('swiper');

      let wrapper = storiesWrapperEl.querySelector('.swiper-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';
        Array.from(storiesWrapperEl.children).forEach(slide => {
          slide.classList.add('swiper-slide');
          wrapper.appendChild(slide);
        });
        if (wrapper.children.length > 0) storiesWrapperEl.appendChild(wrapper);
        else return;
      }

      // Get or create navigation buttons
      let storiesNextBtn = storiesWrapperEl.querySelector('.swiper-button-next');
      let storiesPrevBtn = storiesWrapperEl.querySelector('.swiper-button-prev');

      if (!storiesNextBtn) {
        storiesNextBtn = document.createElement('div');
        storiesNextBtn.className = 'swiper-button-next';
        storiesWrapperEl.appendChild(storiesNextBtn);
      }

      if (!storiesPrevBtn) {
        storiesPrevBtn = document.createElement('div');
        storiesPrevBtn.className = 'swiper-button-prev';
        storiesWrapperEl.appendChild(storiesPrevBtn);
      }

      // Add SVG icons to buttons if available
      if (window.arrows) {
        if (storiesNextBtn && window.arrows.icon_next) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = window.arrows.icon_next;
          const iconSvg = tempDiv.querySelector('svg');
          if (iconSvg) {
            storiesNextBtn.innerHTML = '';
            storiesNextBtn.appendChild(iconSvg.cloneNode(true));
          }
        }
        if (storiesPrevBtn && window.arrows.icon_prev) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = window.arrows.icon_prev;
          const iconSvg = tempDiv.querySelector('svg');
          if (iconSvg) {
            storiesPrevBtn.innerHTML = '';
            storiesPrevBtn.appendChild(iconSvg.cloneNode(true));
          }
        }
      }

      window.storiesSlider = new Swiper(storiesWrapperEl, {
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        navigation: {
          nextEl: storiesNextBtn,
          prevEl: storiesPrevBtn,
        },
          on: {
            init: function() {
              setTimeout(() => {
                const storiesContainer = document.querySelector('.stories-container');
                if (storiesContainer) {
                  storiesContainer.classList.remove('not-slicked');
                }
              }, 1000);
            },
            slideChange: function() {
              const currentIndex = this.activeIndex;
              const prevIndex = this.previousIndex;
              const videos = document.querySelectorAll('.product-story-video video');

              if (videos[prevIndex]) {
                videos[prevIndex].pause();
                if (prevIndex < currentIndex) {
                  if (videos[prevIndex].duration && isFinite(videos[prevIndex].duration)) {
                    videos[prevIndex].currentTime = videos[prevIndex].duration;
                  }
                } else {
                  videos[prevIndex].currentTime = 0;
                }
              }

              if (videos[currentIndex]) {
                videos[currentIndex].pause();
                const nextVideo = videos[currentIndex];
                nextVideo.play();
                nextVideo.muted = false;
              }
            }
          }
        });
      storiesWrapperEl.classList.add('swiper-initialized');
    }

    const videos = document.querySelectorAll('.product-story-video video');
    const timerLines = document.querySelectorAll('#video-timer-wrapper .timer-line');

    function pauseAllVideos() {
      videos.forEach(video => video.pause());
      document.querySelectorAll('.youtube-video').forEach(item => {
        if (item.contentWindow) {
          item.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
        }
      });
    }

    document.querySelectorAll('[data-close-stories]').forEach(item => {
      item.addEventListener('click', function () {
        pauseAllVideos();
        const storiesElement = document.querySelector('[data-stories]');
        if (storiesElement) {
          storiesElement.classList.remove('show-stories');
        }
        document.body.classList.remove('stories-opened');

        if (this.dataset.closeStories === 'calculate') {
          const variantElement = document.querySelector('.productView-moreItem-product-variant');
          const widthSelector = document.querySelector('.width-selector');
          if (variantElement) {
            variantElement.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
          }
          if (widthSelector) {
            widthSelector.focus();
          }
        }
      });
    });

    const tabHandler = document.querySelector('[data-tab-handler]');
    if (tabHandler) {
      tabHandler.addEventListener('click', function () {
        if (this.nextElementSibling) {
          this.nextElementSibling.classList.toggle('open-tab');
        }
      });
    }

    const storiesForm = document.querySelector('.stories-form form');
    if (storiesForm) {
      storiesForm.addEventListener('submit', function (event) {
        event.preventDefault();
        const selectedVariantInput = document.querySelector('#selected-variant');
        if (!selectedVariantInput) return;

        let variantId = Number(selectedVariantInput.value);
        let target = this.querySelector('[data-stories-add-to-cart]');

        if (target) {
          target.classList.add('is-loading');
          Shopify.addItem(variantId, 1, target, () => {
            const storiesElement = document.querySelector('[data-stories]');
            if (storiesElement) {
              storiesElement.classList.remove('show-stories');
            }
            Shopify.getCart((cart) => {
              if (window.updateCart) {
                window.updateCart(cart);
              }
            });
            document.body.classList.add('cart-sidebar-show');
            document.body.classList.remove('stories-opened');
            target.classList.remove('is-loading');
          });
        }
      });
    }

    function findVariantId(options) {
      const variantsJsonInput = document.querySelector('#variants-json');
      if (!variantsJsonInput) return;

      let variants = JSON.parse(variantsJsonInput.value);
      let filteredVariants = variants.filter(variant =>
        Object.keys(options).every(key => variant[key] === options[key])
      );

      if (filteredVariants.length) {
        const selectedVariant = document.querySelector('#selected-variant');
        const buyButton = document.querySelector('[data-stories-add-to-cart]');

        if (selectedVariant) {
          selectedVariant.value = filteredVariants[0].id;
        }

        if (buyButton) {
          if (!filteredVariants[0].available) {
            buyButton.setAttribute('disabled', 'true');
            buyButton.textContent = 'ESGOTADO';
          } else {
            buyButton.removeAttribute('disabled');
            buyButton.textContent = 'ADICIONAR AO CARRINHO';
          }
        }

        if (window.imageSlider && filteredVariants[0].featured_image) {
          const position = filteredVariants[0].featured_image.position || 0;
          window.imageSlider.slideTo(position);
        }
      }
    }

    document.querySelectorAll('.stories-select').forEach(select => {
      select.addEventListener('change', function () {
        let options = {};
        document.querySelectorAll('.stories-select').forEach(sel => {
          options[sel.getAttribute('data-index')] = sel.value;
        });
        findVariantId(options);
      });
    });

    videos.forEach((video, index) => {
      video.addEventListener('timeupdate', function () {
        if (video.duration && timerLines[index]) {
          requestAnimationFrame(() => {
            timerLines[index].style.width = (video.currentTime / video.duration) * 100 + '%';
          });
        }
      });

      video.addEventListener('play', () => {
        if (timerLines[index]) {
          timerLines[index].style.width = '0%';
        }
      });

      video.addEventListener('ended', () => {
        if (timerLines[index]) {
          timerLines[index].style.width = '100%';
        }
        if (index + 1 < videos.length && window.storiesSlider) {
          window.storiesSlider.slideNext();
        }
      });
    });

    // Event listeners para os botões de stories
    let storiesBtn = document.querySelectorAll('[data-open-stories]');

    storiesBtn.forEach((item) => {
      // Verificar se o elemento está dentro de .product-stories-wrapper (não .ig-stories-wrapper)
      const isProductStory = item.closest('.product-stories-wrapper') !== null;

      item.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation(); // Prevenir que outros listeners (como Fancybox) capturem o evento

        // Se for um product-story, garantir que o Fancybox não interfira
        if (isProductStory && typeof Fancybox !== 'undefined') {
          // Fechar qualquer Fancybox que possa ter sido aberto
          try {
            Fancybox.close();
          } catch(err) {
            // Ignorar erros se Fancybox não estiver aberto
          }
        }

        let index = parseInt(item.getAttribute('data-open-stories'));
        let storiesConteiner = document.querySelector('[data-stories]');

        if (storiesConteiner) {
          storiesConteiner.classList.add('show-stories');

          setTimeout(function(){
            if (window.storiesSlider) {
              window.storiesSlider.slideTo(index);
            }
          }, 100);

          setTimeout(() => {
            const slides = storiesConteiner.querySelectorAll('.swiper-slide, .product-story-video');
            let currentSlide = slides[index];
            if (currentSlide) {
              let video = currentSlide.querySelector('video');
              if (video) {
                video.play();
                video.muted = false;
              }
            }
          }, 200);

          document.body.classList.add('stories-opened');
        }
      }, true); // Usar capture: true para garantir que execute antes do Fancybox
    });
  }

  // Initialize on DOM ready
  if (typeof document !== 'undefined' && document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      if (typeof Swiper !== 'undefined' && typeof window.arrows !== 'undefined') {
        initProductStories();
      } else {
        window.addEventListener('load', function() {
          if (typeof Swiper !== 'undefined' && typeof window.arrows !== 'undefined') {
            initProductStories();
          }
        });
      }
    });
  } else {
    if (typeof Swiper !== 'undefined' && typeof window.arrows !== 'undefined') {
      initProductStories();
    } else {
      window.addEventListener('load', function() {
        if (typeof Swiper !== 'undefined' && typeof window.arrows !== 'undefined') {
          initProductStories();
        }
      });
    }
  }
})();
